(function () {
  function initPage(page) {
    if (page.dataset.hoamReady === 'true') return;
    page.dataset.hoamReady = 'true';

    var revealItems = page.querySelectorAll('.hoam-reveal');
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      revealItems.forEach(function (item) { observer.observe(item); });
    } else {
      revealItems.forEach(function (item) { item.classList.add('is-visible'); });
    }

    page.querySelectorAll('[data-hoam-counts]').forEach(function (group) {
      var counters = Array.prototype.slice.call(group.querySelectorAll('[data-hoam-count]'));
      var duration = Number(group.dataset.hoamCountDuration) || 1600;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function animateCounter(counter) {
        if (counter.dataset.hoamCounted === 'true') return;
        counter.dataset.hoamCounted = 'true';
        var finalText = counter.dataset.finalValue || counter.textContent.trim();
        var match = finalText.match(/^([^0-9]*)([0-9][0-9,]*)(.*)$/);
        if (!match) return;
        var target = Number(match[2].replace(/,/g, ''));
        if (!Number.isFinite(target)) return;
        var prefix = match[1];
        var suffix = match[3];
        var useGrouping = match[2].indexOf(',') !== -1;

        function format(value) {
          var number = useGrouping ? value.toLocaleString('en-US') : String(value);
          counter.textContent = prefix + number + suffix;
        }

        if (reduceMotion) {
          counter.textContent = finalText;
          return;
        }

        var startTime;
        format(0);
        function step(time) {
          if (!startTime) startTime = time;
          var progress = Math.min((time - startTime) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          format(Math.round(target * eased));
          if (progress < 1) window.requestAnimationFrame(step);
          else counter.textContent = finalText;
        }
        window.requestAnimationFrame(step);
      }

      if ('IntersectionObserver' in window) {
        var countObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              counters.forEach(animateCounter);
              countObserver.disconnect();
            }
          });
        }, { threshold: 0.3 });
        countObserver.observe(group);
      } else {
        counters.forEach(animateCounter);
      }
    });

    page.querySelectorAll('[data-hoam-craft]').forEach(function (craft) {
      var scene = craft.querySelector('[data-hoam-craft-scene]');
      var number = scene && scene.querySelector('[data-hoam-scene-number]');
      var caption = scene && scene.querySelector('[data-hoam-scene-caption]');
      var image = scene && scene.querySelector('[data-hoam-scene-image]');
      craft.querySelectorAll('[data-hoam-craft-item]').forEach(function (button) {
        button.addEventListener('click', function () {
          craft.querySelectorAll('[data-hoam-craft-item]').forEach(function (item) {
            item.classList.toggle('is-active', item === button);
            item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
          });
          if (!scene) return;
          scene.style.setProperty('--scene-color', button.dataset.color || '#918b80');
          scene.dataset.shape = button.dataset.shape || 'square';
          if (number) number.textContent = button.dataset.number || '';
          if (caption) caption.textContent = button.dataset.caption || '';
          if (image) {
            image.src = button.dataset.image || '';
            image.hidden = !button.dataset.image;
          }
        });
      });
    });

    page.querySelectorAll('[data-hoam-icons]').forEach(function (icons) {
      var tabs = Array.prototype.slice.call(icons.querySelectorAll('[data-hoam-icon-tab]'));
      var stage = icons.querySelector('[data-hoam-icon-stage]');
      var title = stage && stage.querySelector('[data-hoam-icon-title]');
      var subtitle = stage && stage.querySelector('[data-hoam-icon-subtitle]');
      var link = stage && stage.querySelector('[data-hoam-icon-link]');
      var count = stage && stage.querySelector('[data-hoam-icon-count]');
      var image = stage && stage.querySelector('[data-hoam-icon-image]');
      var background = stage && stage.querySelector('[data-hoam-icon-bg]');
      var current = Math.max(0, tabs.findIndex(function (tab) { return tab.classList.contains('is-active'); }));

      function select(index) {
        if (!tabs.length) return;
        current = (index + tabs.length) % tabs.length;
        tabs.forEach(function (tab, i) {
          tab.classList.toggle('is-active', i === current);
          tab.setAttribute('aria-selected', i === current ? 'true' : 'false');
        });
        var tab = tabs[current];
        if (title) title.textContent = tab.dataset.title || '';
        if (subtitle) subtitle.textContent = tab.dataset.subtitle || '';
        if (count) count.textContent = String(current + 1).padStart(2, '0') + ' / ' + String(tabs.length).padStart(2, '0');
        if (background) background.style.setProperty('--icon-bg', tab.dataset.background || 'radial-gradient(circle at 50% 45%,#eee7da,#bdb3a2 70%)');
        if (image) {
          image.src = tab.dataset.image || '';
          image.hidden = !tab.dataset.image;
        }
        if (link) {
          link.href = tab.dataset.url || '#consultation';
          link.textContent = (tab.dataset.linkLabel || 'Discover the icon') + ' ↗';
        }
      }

      tabs.forEach(function (tab, index) { tab.addEventListener('click', function () { select(index); }); });
      var previous = icons.querySelector('[data-hoam-icon-prev]');
      var next = icons.querySelector('[data-hoam-icon-next]');
      if (previous) previous.addEventListener('click', function () { select(current - 1); });
      if (next) next.addEventListener('click', function () { select(current + 1); });
      select(current);
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.hoam-page').forEach(initPage);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
